import { makePostRequest } from 'owa-ows-gateway';
import { TodoFolder } from 'owa-todo-types';
import { TODO_API_GET_LISTS } from '../utils/constants';
import { toTodoFolder } from '../utils/toTodoFolder';
import getTodoRequestHeaders from '../utils/getTodoRequestHeaders';

export default function createTaskFolderService(folder: TodoFolder): Promise<TodoFolder | null> {
    return makePostRequest(
        TODO_API_GET_LISTS,
        { Name: folder.Name }, // TODO: convert TodoFolder to TaskFolder
        null /* correlationId */,
        false /* returnFullResponse */,
        getTodoRequestHeaders() /* customHeaders */
    )
        .then(async (response: any) => {
            return !!response.Id ? toTodoFolder(response) : null;
        })
        .catch(error => {
            return null;
        });
}
